import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { lazyCustom } from '../taboola-common-frontend-modules/lazy-loading/lazyCustom';
import { resolveLazyComponent } from '../taboola-common-frontend-modules/lazy-loading/resolveLazyComponent';
import { withSuspense } from '../taboola-common-frontend-modules/lazy-loading/withSuspense';
import { ONBOARDING_FORM_PATH, ONBOARDING_JOURNEY_PATH, ONBOARDING_FORM_REDIRECT_PATH } from './config/routeTypes';

const OnboardingChatFormLazy = lazyCustom(() =>
    import('./OnboardingChatForm/OnboardingChatForm').then(resolveLazyComponent('OnboardingChatForm'))
);
const OnboardingChatForm = withSuspense(OnboardingChatFormLazy);

const OnboardingJourneyFormLazy = lazyCustom(() =>
    import('./OnboardingJourneyForm/OnboardingJourneyForm').then(resolveLazyComponent('OnboardingJourneyForm'))
);
const OnboardingJourneyForm = withSuspense(OnboardingJourneyFormLazy);

export const Onboarding = () => (
    <Switch>
        <Route path={ONBOARDING_FORM_PATH} exact render={props => <OnboardingChatForm {...props} />} />
        <Route path={ONBOARDING_JOURNEY_PATH} exact render={props => <OnboardingJourneyForm {...props} />} />
        <Redirect to={ONBOARDING_FORM_REDIRECT_PATH} />
    </Switch>
);
